import request from '@/utils/request'
// import { getProvider } from '@/utils'

// 登录 获取token
export function CommonUploadToken(params) {
    return request({
        url: '/common/upload-token',
        method: 'get',
        params
    })
}

// 文件分类列表  二级
export function GetFileCategory(params) {
    return request({
        url: '/file-category',
        method: 'get',
        params
    })
}
// 新增类别
export function PostFileCategory(params) {
    return request({
        url: '/file-category',
        method: 'post',
        params
    })
}


// 文件类别列表  三级
export function GetCommonFile(params) {
    return request({
        url: '/common/file',
        method: 'get',
        params
    })
}


// 获取阿里token
export function GetAliToken(params) {
    return request({
        url: '/common/ali/token',
        method: 'get',
        params
    })
}

// 获取登录信息
export function getInfo(params) {
    return request({
        url: '/common/info',
        method: 'get',
        params
    })
}

